
// Suppress benign ResizeObserver errors which are common with resizable panels
// and do not affect functionality.

const IGNORED_ERRORS = [
    /ResizeObserver loop/,
    /ResizeObserver loop completed with undelivered notifications/,
    /ResizeObserver loop limit exceeded/
];

const originalError = console.error;
console.error = (...args) => {
    if (
        args[0] &&
        typeof args[0] === 'string' &&
        IGNORED_ERRORS.some((pattern) => pattern.test(args[0]))
    ) {
        return;
    }
    originalError.apply(console, args);
};

// Use capture phase to intercept errors before React's error boundary or overlay
window.addEventListener(
    'error',
    (event) => {
        const message = event.message || (event.error && event.error.message) || '';
        if (
            message &&
            typeof message === 'string' &&
            IGNORED_ERRORS.some((pattern) => pattern.test(message))
        ) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
            return false;
        }
    },
    { capture: true }
);

// Fallback for older global handler mechanism
const originalOnError = window.onerror;
window.onerror = (msg, source, lineno, colno, error) => {
    const message = msg || (error && error.message) || '';
    if (
        message &&
        typeof message === 'string' &&
        IGNORED_ERRORS.some((pattern) => pattern.test(message))
    ) {
        return true; // Suppress
    }
    if (originalOnError) {
        return originalOnError(msg, source, lineno, colno, error);
    }
};

// Suppress unhandled rejections for ResizeObserver errors
window.addEventListener('unhandledrejection', (event) => {
    const message = event.reason?.message || String(event.reason) || '';
    if (IGNORED_ERRORS.some((pattern) => pattern.test(message))) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
}, { capture: true });

// Override ErrorEvent constructor to filter before React overlay sees it
if (typeof ErrorEvent !== 'undefined') {
    const OriginalErrorEvent = ErrorEvent;
    window.ErrorEvent = function(type, init) {
        if (init?.message && IGNORED_ERRORS.some((p) => p.test(init.message))) {
            return null;
        }
        return new OriginalErrorEvent(type, init);
    };
    window.ErrorEvent.prototype = OriginalErrorEvent.prototype;
}
